import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	settingsId: string;
	onChange: (value: string) => void;
}

export const KmBalanceAccountIdField: React.FC<IProps> = React.memo(({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterKmBalanceAccountId') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const trimmed = e.target.value.trim();
			onChange(trimmed);
			return trimmed;
		},
		[onChange],
	);

	return (
		<FormInput
			testId="KmBalanceAccountIdField"
			name={`kmBalanceAccountId-${settingsId}`}
			label="kmBalanceAccountIdLabel"
			maxLength={50}
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
});
